<!--
    file type .....: HTML file: message-detail.component.html
    Created By ....: ianday
    Date ..........: 1/10/24 
-->

<div class="message-body-container">

   <div style="padding-bottom: 5px;">
        <label>Message Body Template:</label>
   </div>

   <textarea id="messageBodyDetail"
             (change)="doCursorPositioning($event)"
             class="text-area-input text-area-override"
             [(ngModel)]="_messageBody"
             ></textarea>

</div>
<div class="tokens-container">

   <div style="padding-bottom: 5px;">
       <label style="padding-bottom:8px;">Message Tokens (Used for data merge):</label>
   </div>

    <div class="filter-div-class">
        <label>Filter: </label>
        <input type="search"
               (input)="applyFilter($event.target.value)"
               (keyup)="applyFilter($event.target.value)"
               class="filter-input-class-override">
    </div>

    <div class="table-container mat-elevation-z1"
         (keydown)="tableKeyDown($event)" tabindex="-1">

        <table mat-table [dataSource]="dataSource">
            <!-- token -->
            <ng-container matColumnDef="token">
                <th mat-header-cell *matHeaderCellDef class="token-table-class"
                    style="background-color: white; z-index:99999; width: 150px;">Token
                </th>
                <td mat-cell style="width:150px!important;" class="token-table-class"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{ element.token }}
                </td>
            </ng-container>

            <!-- Description -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef class="token-table-class"
                    style="background-color: white; z-index:99999; width:300px;">Description
                </th>
                <td mat-cell style="width:300px!important;" class="token-table-class"
                    *matCellDef="let element">{{ element.description }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)"
                (dblclick)="selectAndCopy()">
            </tr>
        </table>

    </div>

</div>
<div *ngIf="copyVisible" id="copyMessageId" class="copy-message-style">Copied to clipboard</div>
<!----------------------->
<!-- ERROR LINE --------->
<!----------------------->
<div class="error-line" [hidden]='!strErr.length'
     style="text-align:left;margin-bottom: 5px;margin-left: 3px;">{{strErr}}</div>
<!----------------------->
<!-- SAVE STRIP        -->
<!----------------------->
<div class="save-close-strip" style="bottom: 10px;">

    <button mat-button class="command-button"
            (click)="submitRecord()" matTooltip="Save the record"
            mat-button>
        <mat-icon>check_circle_outline</mat-icon>
        Submit
    </button>
    <button mat-button class="command-button"
            (click)="cancelSubmitRecord()" matTooltip="Close window" mat-button>
        <mat-icon>highlight_off</mat-icon>
        Cancel
    </button>
</div>
